import { allConditionalSteps, getStepNamesAccordingToChoices } from './steps';
import { ConditionParams } from './utils/types';

export const getStepIndex = (params: ConditionParams, currentRoute: string) =>
  getStepNamesAccordingToChoices(allConditionalSteps, params).findIndex(
    (x) => x === currentRoute
  );

export const getNextStep = (params: ConditionParams, currentRoute: string) =>
  getStepNamesAccordingToChoices(allConditionalSteps, params)[
    getStepIndex(params, currentRoute) + 1
  ];

export const getPreviousStep = (
  params: ConditionParams,
  currentRoute: string
) =>
  getStepNamesAccordingToChoices(allConditionalSteps, params)[
    getStepIndex(params, currentRoute) - 1
  ];
